import { render, staticRenderFns } from "./WordViewer.vue?vue&type=template&id=6d0e9132&scoped=true"
import script from "./WordViewer.vue?vue&type=script&lang=js"
export * from "./WordViewer.vue?vue&type=script&lang=js"
import style0 from "./WordViewer.vue?vue&type=style&index=0&id=6d0e9132&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d0e9132",
  null
  
)

export default component.exports